import type { FC, ReactNode } from "react";

import { ArrowDiagonalUpRightIcon, Box, Row } from "@hightouch/htui";

import { RouterLink } from "src/router";
import { HOME_HOVER_BG } from "src/pages/home/agentic/styles";

type HoverableListItemProps = {
  to: string;
  onClick?: () => void;
  children: ReactNode;
};

export const HoverableListItem: FC<HoverableListItemProps> = ({
  to,
  onClick,
  children,
}) => (
  <Row
    as={RouterLink}
    to={to}
    onClick={onClick}
    align="center"
    gap={3}
    p={2}
    borderRadius="2xl"
    className="group"
    transitionProperty="background-color"
    transitionDuration="fast"
    transitionTimingFunction="easeOutQuad"
    sx={{
      "@media (hover: hover)": {
        _hover: { bg: HOME_HOVER_BG },
      },
    }}
  >
    {children}
    <Box
      as={ArrowDiagonalUpRightIcon}
      boxSize={4}
      color="text.secondary"
      flexShrink={0}
      opacity={0}
      transitionProperty="opacity"
      transitionDuration="fast"
      transitionTimingFunction="easeOutQuad"
      sx={{
        "@media (hover: hover)": {
          ".group:hover &": { opacity: 1 },
        },
      }}
    />
  </Row>
);
